"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemQuantityWidth = void 0;
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var FakeNumberInput_1 = __importDefault(require("QuoteV2/Components/FakeNumberInput"));
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var react_1 = __importDefault(require("react"));
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var ItemQuantityWidth;
(function (ItemQuantityWidth) {
    ItemQuantityWidth["Fixed"] = "fixed";
    ItemQuantityWidth["Dynamic"] = "dynamic";
})(ItemQuantityWidth || (exports.ItemQuantityWidth = ItemQuantityWidth = {}));
var ItemQuantity = (function (_super) {
    __extends(ItemQuantity, _super);
    function ItemQuantity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ItemQuantity.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, section = _b.section, item = _b.item, _c = _b.syncQuantity, syncQuantity = _c === void 0 ? false : _c;
        if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
            if (item.isQuantityOptional) {
                return (react_1.default.createElement("div", { className: "section__quantity" },
                    react_1.default.createElement("div", { "data-qwilr-component": this.props["data-qwilr-component"] ? "plan-card-quantity-section" : null, onClick: function (event) {
                            event.stopPropagation();
                        }, className: "section__quantity-value" },
                        react_1.default.createElement(kaleidoscope_1.NumberInput, { autoGrow: true, label: "Quantity", labelHidden: true, variant: "underlined", size: "s", value: item.quantity, onChange: function (value) {
                                var e_1, _a;
                                item.quantity = value;
                                if (syncQuantity && item.isQuantityOptional) {
                                    try {
                                        for (var _b = __values(section.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                                            var sectionItem = _c.value;
                                            if (sectionItem !== item &&
                                                sectionItem instanceof QuoteItemStore_1.QuotePricedItemStore &&
                                                sectionItem.isQuantityOptional &&
                                                sectionItem.unit === item.unit) {
                                                sectionItem.quantity = value;
                                            }
                                        }
                                    }
                                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                                    finally {
                                        try {
                                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                        }
                                        finally { if (e_1) throw e_1.error; }
                                    }
                                }
                                _this.quoteTelemetry.trackLineItemQuantityChanged(section.displayMode);
                            }, min: item.quantityOptionalMin, max: item.quantityOptionalMax, disabled: !this.quoteViewStore.isInteractive, "data-qwilr-component": this.props["data-qwilr-component"] ? this.props["data-qwilr-component"] : null })),
                    react_1.default.createElement("span", { className: "section__quantity-unit" }, item.unit)));
            }
            return (react_1.default.createElement("div", { className: "section__quantity", suppressHydrationWarning: true },
                react_1.default.createElement("span", { className: "section__quantity-value" }, item.quantity),
                react_1.default.createElement("span", { className: "section__quantity-unit" }, item.unit)));
        }
        if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
            return (react_1.default.createElement("div", { className: "section__quantity", suppressHydrationWarning: true },
                react_1.default.createElement(FakeNumberInput_1.default, { editable: item.isQuantityOptional },
                    react_1.default.createElement("div", null, "p.".concat(ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.getMappedProductFieldName(Types_1.ProductMappedField.Quantity, (_a = item.token.substitutionToken) === null || _a === void 0 ? void 0 : _a.id))))));
        }
        return null;
    };
    var _a, _b;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _a : Object)
    ], ItemQuantity.prototype, "quoteTelemetry", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_b = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _b : Object)
    ], ItemQuantity.prototype, "quoteViewStore", void 0);
    ItemQuantity = __decorate([
        mobx_react_1.observer
    ], ItemQuantity);
    return ItemQuantity;
}(react_1.default.Component));
exports.default = ItemQuantity;
